function handleCollapseButton(event, title, ...selectors) {
  const button = event.target.closest("button")

  button.classList.toggle("btn-collapse--active")

  if (button.classList.contains("btn-collapse--active")) {
    dataLayer.push({
      event: "sub_nav_menu",
      link_text: title,
      nav_type: "TopNav",
      page_location: window.location.href,
    })
  }

  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      if (element.classList.contains("collapse--active")) {
        element.setAttribute("aria-hidden", "true")
      } else {
        element.setAttribute("aria-hidden", "false")
      }
      element.classList.toggle("collapse--active")
    })
  })
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".menu-drawer__menu > li").forEach((li) => {
    const button = li.querySelector(".btn-collapse")
    const wrapper = li.querySelector(".menu-item-link")
    const link = li.querySelector("a.link")

    if (!wrapper) return
    if (button && link) {
      const style = window.getComputedStyle(button)
      if (
        style.opacity !== "0" &&
        style.display !== "none" &&
        style.visibility !== "hidden"
      ) {
        link.removeAttribute("href")
        link.style.pointerEvents = "none"
        link.style.cursor = "default"
      }
    }

    wrapper.addEventListener("click", function (event) {
      const isButton = button?.contains(event.target)
      const isLink = link?.contains(event.target)

      if (isButton) return
      if (button) {
        const style = window.getComputedStyle(button)
        if (
          style.opacity !== "0" &&
          style.display !== "none" &&
          style.visibility !== "hidden"
        ) {
          event.preventDefault()
          button.click()
        }
      }
    })
  })

  document.querySelectorAll(".menu-item-submenu-list").forEach((submenuLi) => {
    const button = submenuLi.querySelector(".btn-collapse")
    const header = submenuLi.querySelector(".menu-item-submenu-header")

    if (!button || !header) return

    const link = header.querySelector("a.link")
    if (link && button) {
      const style = window.getComputedStyle(button)
      if (
        style.opacity !== "0" &&
        style.display !== "none" &&
        style.visibility !== "hidden"
      ) {
        link.removeAttribute("href")
        link.style.pointerEvents = "none"
        link.style.cursor = "default"
      }
    }

    header.addEventListener("click", function (event) {
      const isButton = button.contains(event.target)
      if (!isButton) {
        button.click()
        event.stopPropagation()
      }
    })
  })

  document.querySelectorAll(".btn-collapse").forEach((btn) => {
    btn.addEventListener("click", (e) => e.stopPropagation())
  })

  initExploreLearnTileTitleEqualHeights()
})

/**
 * Tablet only: match .menu-item-submenu-list-title min-heights within each grid row
 * for #explore and #learn image tiles in the menu drawer.
 *
 * Must scope to #menu-drawer: the same ids exist on the desktop dropdown markup, and
 * getElementById would otherwise target the wrong (often hidden) subtree.
 */
function initExploreLearnTileTitleEqualHeights() {
  const TABLET_MQ = "(min-width: 768px) and (max-width: 1199px)"
  const SECTION_IDS = ["explore", "learn"]
  const DRAWER_SELECTOR = "#menu-drawer"
  const SUBMENU_TRANSITION_MS = 350

  function isTabletViewport() {
    return window.matchMedia(TABLET_MQ).matches
  }

  function debounce(fn, ms) {
    let t
    return function (...args) {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), ms)
    }
  }

  function getDrawerSectionRoot(id) {
    const drawer = document.querySelector(DRAWER_SELECTOR)
    if (!drawer) return null
    return drawer.querySelector(`#${CSS.escape(id)}`)
  }

  function getGridColumnCount(ul) {
    const raw = window.getComputedStyle(ul).gridTemplateColumns
    if (!raw || raw === "none") return 2
    const repeatMatch = raw.match(/repeat\s*\(\s*(\d+)/i)
    if (repeatMatch) {
      const n = parseInt(repeatMatch[1], 10)
      return Number.isFinite(n) && n > 0 ? n : 2
    }
    const parts = raw.split(/\s+/).filter(Boolean)
    return parts.length > 0 ? parts.length : 2
  }

  function clearTitleMinHeights(root) {
    if (!root) return
    root.querySelectorAll(".menu-item-submenu-list-title").forEach((el) => {
      el.style.minHeight = ""
    })
  }

  function equalizeSection(root) {
    if (!root) return

    clearTitleMinHeights(root)

    if (!isTabletViewport() || !root.classList.contains("collapse--active")) {
      return
    }

    const ul = root.querySelector(".menu-item-submenu-nav")
    if (!ul) return

    const titles = [
      ...ul.querySelectorAll(":scope > .menu-item-submenu-list"),
    ].map((li) => li.querySelector(".menu-item-submenu-list-title"))

    if (titles.some((t) => !t)) return

    const colCount = getGridColumnCount(ul)
    const rowCount = Math.ceil(titles.length / colCount)

    for (let row = 0; row < rowCount; row++) {
      const slice = []
      for (let col = 0; col < colCount; col++) {
        const i = row * colCount + col
        if (i < titles.length) slice.push(titles[i])
      }
      if (slice.length < 2) continue

      let maxH = 0
      for (const el of slice) {
        const h = el.getBoundingClientRect().height
        if (h > maxH) maxH = h
      }

      const px = `${Math.ceil(maxH)}px`
      for (const el of slice) {
        el.style.minHeight = px
      }
    }
  }

  function runAll() {
    for (const id of SECTION_IDS) {
      equalizeSection(getDrawerSectionRoot(id))
    }
  }

  const debouncedRun = debounce(runAll, 120)

  function runAfterSubmenuTransition() {
    window.setTimeout(runAll, SUBMENU_TRANSITION_MS)
  }

  for (const id of SECTION_IDS) {
    const root = getDrawerSectionRoot(id)
    if (!root) continue
    new MutationObserver(() => {
      debouncedRun()
      if (root.classList.contains("collapse--active")) {
        runAfterSubmenuTransition()
      }
    }).observe(root, {
      attributes: true,
      attributeFilter: ["class"],
    })
  }

  window.addEventListener("resize", debouncedRun)

  const drawerDetails = document.getElementById("Details-menu-drawer-container")
  drawerDetails?.addEventListener("toggle", () => {
    debouncedRun()
    if (drawerDetails.open) {
      runAfterSubmenuTransition()
    }
  })

  if (document.fonts?.ready) {
    document.fonts.ready.then(debouncedRun).catch(() => {})
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(debouncedRun)
  })
}
